export default "__VITE_ASSET__8s2YEpQE__"